import { useTVScale } from './TVScaleContext';

/**
 * Empty state del carril “Últimos resultados” cuando el torneo todavía está
 * en fase de grupos y no hay partidos jugados.
 *
 * Portado de `V1_StartFlag` del mockup “Empty States · Últimos Resultados”.
 * Mantiene paleta, animaciones (`esCheckered`, `esFloat`, `esPulse` definidos
 * en `src/index.css`) y composición; usa `font-gilroy` para el título en lugar
 * de la Barlow Condensed del mockup, alineado con el resto del Modo TV.
 */
export const EmptyStateGrupos = () => {
  const { s } = useTVScale();
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        background:
          'linear-gradient(115deg, #023373 0%, #034A9E 55%, #4BD32F 140%)',
        borderRadius: 6,
      }}
    >
      {/* Patrón de bandera a cuadros animado, sutil al fondo */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.13,
          backgroundImage:
            'linear-gradient(45deg,#fff 25%,transparent 25%,transparent 75%,#fff 75%),linear-gradient(45deg,#fff 25%,transparent 25%,transparent 75%,#fff 75%)',
          backgroundSize: '24px 24px',
          backgroundPosition: '0 0, 12px 12px',
          animation: 'esCheckered 18s linear infinite',
        }}
      />
      {/* Halo verde */}
      <div
        style={{
          position: 'absolute',
          right: -40,
          top: -40,
          width: 160,
          height: 160,
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(75,211,47,.45) 0%, transparent 70%)',
        }}
      />

      <div
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: `${s(12)}px ${s(22)}px`,
          gap: s(20),
        }}
      >
        {/* Bandera ícono */}
        <div
          style={{
            flexShrink: 0,
            width: s(64),
            height: s(64),
            position: 'relative',
            animation: 'esFloat 3s ease-in-out infinite',
          }}
        >
          <svg viewBox="0 0 44 44" width={s(64)} height={s(64)}>
            <rect x="6" y="3" width="2" height="38" fill="#fff" />
            <g transform="translate(8,5)">
              <rect width="30" height="20" fill="#fff" rx="1" />
              {[0, 1, 2, 3, 4].flatMap((c) =>
                [0, 1, 2].map((r) => (
                  <rect
                    key={`${c}-${r}`}
                    x={c * 6}
                    y={r * 6.66}
                    width="6"
                    height="6.66"
                    fill={(c + r) % 2 === 0 ? '#023373' : 'transparent'}
                  />
                )),
              )}
            </g>
          </svg>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            className="font-gilroy"
            style={{
              fontSize: s(26),
              fontWeight: 900,
              color: '#fff',
              lineHeight: 1.05,
              letterSpacing: '0.01em',
              textTransform: 'uppercase',
            }}
          >
            El torneo está por comenzar
          </div>
          <div
            style={{
              fontSize: s(15),
              color: 'rgba(255,255,255,.82)',
              marginTop: s(5),
              fontWeight: 500,
            }}
          >
            Muy pronto los primeros resultados
          </div>
        </div>
        <div
          style={{
            flexShrink: 0,
            background: '#fff',
            color: '#023373',
            padding: `${s(7)}px ${s(14)}px`,
            borderRadius: 4,
            fontSize: s(12),
            fontWeight: 800,
            letterSpacing: '0.1em',
            animation: 'esPulse 2.5s infinite',
          }}
        >
          PRÓXIMAMENTE
        </div>
      </div>
    </div>
  );
};
